import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "dialog-custom__header mb-4" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = { style: {"width":"450px","height":"calc(100vh - 350px)"} }
const _hoisted_5 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_6 = { class: "p-field" }
const _hoisted_7 = { class: "p-field-label" }
const _hoisted_8 = { class: "p-field" }
const _hoisted_9 = { class: "p-field-label" }
const _hoisted_10 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_11 = { class: "p-field" }
const _hoisted_12 = {
  class: "p-field-label",
  for: "switchboardname"
}
const _hoisted_13 = {
  for: "switchboardname",
  class: "fs-13 label-error"
}
const _hoisted_14 = { class: "p-field" }
const _hoisted_15 = {
  class: "p-field-label",
  for: "switchboardscs"
}
const _hoisted_16 = {
  for: "switchboardscs",
  class: "fs-13 label-error"
}
const _hoisted_17 = {
  key: 0,
  class: "p-field"
}
const _hoisted_18 = {
  class: "p-field-label",
  for: "building"
}
const _hoisted_19 = { class: "p-field" }
const _hoisted_20 = {
  class: "p-field-label",
  for: "switchboardriser"
}
const _hoisted_21 = { class: "p-field mb-3" }
const _hoisted_22 = { class: "p-field-label my-4" }
const _hoisted_23 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputText = _resolveComponent("InputText")
  const _component_ListItemCheck = _resolveComponent("ListItemCheck")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_ctx.newSwitchboard && _ctx.newSwitchboard.switchboard)
    ? (_openBlock(), _createBlock(_component_Dialog, {
        key: 0,
        visible: _ctx.isDialogVisible,
        "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (_ctx.isDialogVisible = $event)),
        onHide: _ctx.doHideDialog,
        modal: true,
        showHeader: false,
        closable: false,
        class: "dialog-custom"
      }, {
        default: _withCtx(() => [
          _createVNode("header", _hoisted_1, [
            _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.dialogTitle), 1)
          ]),
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_ElScrollbar, { class: "dialog-scroll" }, {
                default: _withCtx(() => [
                  (_ctx.step == 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_5, [
                        _createVNode("div", _hoisted_6, [
                          _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("AppResourceEP.Building")), 1),
                          _createVNode(_component_Dropdown, {
                            class: "w-100",
                            options: _ctx.buildings,
                            disabled: _ctx.buildings.length === 1,
                            optionLabel: "name",
                            modelValue: _ctx.selectedBuilding,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedBuilding = $event))
                          }, null, 8, ["options", "disabled", "modelValue"])
                        ]),
                        _createVNode("div", _hoisted_8, [
                          _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("AppResourceEP.Riser")), 1),
                          _createVNode(_component_Dropdown, {
                            class: "w-100",
                            options: _ctx.buildingRisers,
                            disabled: _ctx.buildingRisers.length === 1,
                            optionLabel: "name",
                            optionValue: "riserInterfaceId",
                            modelValue: _ctx.newSwitchboard.switchboard.riserInterfaceId,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.newSwitchboard.switchboard.riserInterfaceId = $event))
                          }, null, 8, ["options", "disabled", "modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.step == 1)
                    ? (_openBlock(), _createBlock("div", _hoisted_10, [
                        _createVNode("div", _hoisted_11, [
                          _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("AppResource.NameUpper")), 1),
                          _createVNode(_component_InputText, {
                            id: "switchboardname",
                            type: "text",
                            class: ["w-100", { 'input-error': !_ctx.isValidName }],
                            validator: '/^(?!\s).+(?<!\s)$',
                            modelValue: _ctx.newSwitchboard.switchboard.name,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.newSwitchboard.switchboard.name = $event)),
                            maxlength: _ctx.nameMaxLength
                          }, null, 8, ["validator", "modelValue", "maxlength", "class"]),
                          _createVNode("label", _hoisted_13, _toDisplayString(_ctx.invalidNameReason), 1)
                        ]),
                        _createVNode("div", _hoisted_14, [
                          _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("AppResourceEP.DeviceScsAddress")), 1),
                          _createVNode(_component_InputText, {
                            id: "switchboardscs",
                            type: "number",
                            class: ["w-100", { 'input-error': !_ctx.isValidScs }],
                            min: 0,
                            max: 15,
                            modelValue: _ctx.newSwitchboard.switchboard.scsAddr,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.newSwitchboard.switchboard.scsAddr = $event))
                          }, null, 8, ["modelValue", "class"]),
                          _createVNode("label", _hoisted_16, _toDisplayString(_ctx.invalidScsReason), 1)
                        ]),
                        (_ctx.currentEntrancePlant.hasRiserInterface)
                          ? (_openBlock(), _createBlock("div", _hoisted_17, [
                              _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("AppResourceEP.Building")), 1),
                              _createVNode(_component_InputText, {
                                id: "building",
                                class: "w-100",
                                value: _ctx.getBuildingName(_ctx.newSwitchboard.switchboard),
                                disabled: ""
                              }, null, 8, ["value"])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode("div", _hoisted_19, [
                          _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("AppResourceEP.Riser")), 1),
                          _createVNode(_component_InputText, {
                            id: "switchboardriser",
                            class: "w-100",
                            value: _ctx.getRiserName(_ctx.newSwitchboard.switchboard),
                            disabled: ""
                          }, null, 8, ["value"])
                        ]),
                        _createVNode("div", _hoisted_21, [
                          _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("SelectDevicesInGate")), 1),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.devices, (option, i) => {
                            return (_openBlock(), _createBlock(_component_ListItemCheck, {
                              key: i,
                              modelValue: _ctx.switchboardDevicesIds,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.switchboardDevicesIds = $event)),
                              label: option.device.deviceName,
                              value: option.device.deviceId,
                              name: "device",
                              inputId: option.device.deviceId,
                              last: i === _ctx.devices.length - 1
                            }, null, 8, ["modelValue", "label", "value", "inputId", "last"]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode("footer", _hoisted_23, [
            _createVNode(_component_Button, {
              class: "p-button-text mr-2",
              onClick: _ctx.handleHideDialog
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.step == 0 || _ctx.isEdit || !_ctx.currentEntrancePlant.hasRiserInterface ? _ctx.$t("AppResource.Cancel") : _ctx.$t("AppResource.Back")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_Button, {
              label: _ctx.buttonSubmitLabel,
              onClick: _ctx.handleButtonSubmitAction,
              class: "p-button-rounded p-button-raised p-button--m",
              disabled: _ctx.saveButtonDisabled
            }, null, 8, ["label", "onClick", "disabled"])
          ])
        ]),
        _: 1
      }, 8, ["visible", "onHide"]))
    : _createCommentVNode("", true)
}